import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminRoute = ({ children }) => {
  const isAuth = useSelector((state) => state.auth.isAuthorized);
  const isAdmin = useSelector((state) => state.user.user?.admin);
  const location = useLocation();

  if (!isAuth) {
    const prev = sessionStorage.getItem('previousPath');
    if (!prev) {
      sessionStorage.setItem('previousPath', location.pathname);
    }
    return <Navigate to="/sign-in" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
